import React from "react";
import { Box, Typography } from "@mui/material";

interface EmptyStateProps {
  image: string;
  text: string;
  actionButtons: React.ReactNode;
}

const EmptyState: React.FC<EmptyStateProps> = ({
  image,
  text,
  actionButtons,
}) => {
  return (
    <Box textAlign="center" mt={5} sx={{ width: "100%" }}>
      <img
        src={image}
        alt="Empty state"
        style={{ width: "300px", marginBottom: "20px" }}
      />
      <Typography variant="h6" gutterBottom>
        {text}
      </Typography>
      <Box>{actionButtons}</Box>
    </Box>
  );
};

export default EmptyState;
